import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { permissionsService } from '@/services/api/permissions.service'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../queryKeys'

async function getPermissions() {
  const response = await permissionsService.getPermissions()
  return response.data
}

export function useGetPermissions() {
  const { isAuthenticated } = useCognitoAuth()

  return useQuery({
    queryKey: [QUERY_KEYS.permissions.getAll],
    queryFn: () => getPermissions(),
    enabled: isAuthenticated,
  })
}
